<template>
  <div class="vx-card">
    <div class="vx-card__body card-body">
      <div class="vx-row mb-6">
        <div class="vx-col w-full mb-2">
          <vs-button @click="createAccount()" class="bg_l_green">
            <feather-icon
              icon="PlusIcon"
              svgClasses="h-4 w-4"
              class="ico"
              v-has-permission="'CreateUnitOfMeasure'"
            />
            {{ $t("CreateUnit") }}
          </vs-button>
        </div>
      </div>
      <modify-popup
        :show="ModifyPopup"
        :model="modalModel"
        @finish="onfinish"
        @close="closeModifyPopup"
      >
      </modify-popup>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('ID'), sort: 'ID' },
              { title: $t('Unit'), sort: 'Unit' },
              { title: $t('CreateOn'), sort: 'CreateOn' },
              { title: $t('Action') },
            ]"
          >
            <template slot-scope="{ row }">
              <td>
                {{ row.id ? row.id : "-" }}
              </td>

              <td>
                {{ row.name }}
              </td>

              <td>
                {{ row.persianCreateOn ? row.persianCreateOn : "-" }}
              </td>
              <td>
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  v-has-permission="'ModifyUnitOfMeasure'"
                  @click.prevent="editAccount(row)"
                  class="ml-4 d-inline"
                ></vs-button>
                <vs-button
                  radius
                  color="danger"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="deleteAccount(row.id)"
                  class="ml-4 d-inline"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./CreateUnit.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "/Procurements/api/UnitOfMeasuresQuery/by-paging",
      },
      gridSearchData: {},
    };
  },
  methods: {
    ...mapActions({
      deleteUnit: "unit/deleteUnit",
    }),
    ////Open Modal In Create Mode
    createAccount() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    /////AddChild
    editAccount(model) {
      this.modalModel = { id: model.id, name: model.name };
      this.ModifyPopup = true;
    },
    deleteAccount(model) {
      this.$swal({
        position: "center-center",
        text: "آیا از حذف این آیتم اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.deleteUnit(model).then(() => {
            this.$refs.grid.renderGrid();
            this.$swal({
              position: "center-center",
              type: "success",
              text: "آیتم با موفقیت حذف شد",
              showConfirmButton: false,
              timer: 2000,
            });
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
